import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';
import { useTheme } from '@mui/material';

export const Fundraise = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <CurrencyPoundIcon
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
